import { useEffect } from "react";

// useEffect that runs only once (on mount)
export default function useOnMount(fn) {
  return useEffect(fn, []);
}
